import { rootApi as api } from '../rootApi';
export const addTagTypes = ['Reports'] as const;
const injectedRtkApi = api
    .enhanceEndpoints({
        addTagTypes,
    })
    .injectEndpoints({
        endpoints: build => ({
            getApiFmByFlidReports: build.query<
                GetApiFmByFlidReportsApiResponse,
                GetApiFmByFlidReportsApiArg
            >({
                query: queryArg => ({
                    url: `/api/fm/${queryArg.flid}/reports`,
                    params: {
                        reportType: queryArg.reportType,
                        fileType: queryArg.fileType,
                        filterDate: queryArg.filterDate,
                    },
                }),
                providesTags: ['Reports'],
            }),
            getApiFmByFlidReportsJson: build.query<
                GetApiFmByFlidReportsJsonApiResponse,
                GetApiFmByFlidReportsJsonApiArg
            >({
                query: queryArg => ({
                    url: `/api/fm/${queryArg.flid}/reports/json`,
                    params: {
                        reportName: queryArg.reportName,
                        dbParams: queryArg.dbParams,
                        camelCase: queryArg.camelCase,
                    },
                }),
                providesTags: ['Reports'],
            }),
            getApiFmByFlidReportsCsv: build.query<
                GetApiFmByFlidReportsCsvApiResponse,
                GetApiFmByFlidReportsCsvApiArg
            >({
                query: queryArg => ({
                    url: `/api/fm/${queryArg.flid}/reports/csv`,
                    params: {
                        reportName: queryArg.reportName,
                        dbParams: queryArg.dbParams,
                    },
                }),
                providesTags: ['Reports'],
            }),
            getApiFmByFlidReportsExcel: build.query<
                GetApiFmByFlidReportsExcelApiResponse,
                GetApiFmByFlidReportsExcelApiArg
            >({
                query: queryArg => ({
                    url: `/api/fm/${queryArg.flid}/reports/excel`,
                    params: {
                        reportName: queryArg.reportName,
                        dbParams: queryArg.dbParams,
                    },
                }),
                providesTags: ['Reports'],
            }),
            getApiFmByFlidReportsSpecs: build.query<
                GetApiFmByFlidReportsSpecsApiResponse,
                GetApiFmByFlidReportsSpecsApiArg
            >({
                query: queryArg => ({
                    url: `/api/fm/${queryArg.flid}/reports/specs`,
                    params: {
                        reportName: queryArg.reportName,
                    },
                }),
                providesTags: ['Reports'],
            }),
            postApiFmByFlidReportsRequests: build.mutation<
                PostApiFmByFlidReportsRequestsApiResponse,
                PostApiFmByFlidReportsRequestsApiArg
            >({
                query: queryArg => ({
                    url: `/api/fm/${queryArg.flid}/reports/requests`,
                    method: 'POST',
                    params: {
                        reportName: queryArg.reportName,
                        dbParams: queryArg.dbParams,
                        outputType: queryArg.outputType,
                        camelCase: queryArg.camelCase,
                    },
                }),
                invalidatesTags: ['Reports'],
            }),
            getApiFmByFlidReportsAndToken: build.query<
                GetApiFmByFlidReportsAndTokenApiResponse,
                GetApiFmByFlidReportsAndTokenApiArg
            >({
                query: queryArg => ({
                    url: `/api/fm/${queryArg.flid}/reports/${queryArg.token}`,
                }),
                providesTags: ['Reports'],
            }),
        }),
        overrideExisting: false,
    });
export { injectedRtkApi as baseReportsApi };
export type GetApiFmByFlidReportsApiResponse = unknown;
export type GetApiFmByFlidReportsApiArg = {
    flid: number;
    reportType: FeedlotManagerCommonEnumsReportTypeEnum;
    fileType: FeedlotManagerCommonEnumsFileTypeEnum;
    filterDate?: string;
};
export type GetApiFmByFlidReportsJsonApiResponse = unknown;
export type GetApiFmByFlidReportsJsonApiArg = {
    /** Feedlot Id */
    flid: number;
    /** Name of the raw SQL file */
    reportName: string;
    /** Name(s) of the raw SQL variables used. Do not need to add FeedLotId or TimezoneOffset variables. For "bit" use true/false, not 1 or 0. */
    dbParams?: {
        [key: string]: string;
    };
    /** specifies if camel case property names should be used */
    camelCase?: boolean;
};
export type GetApiFmByFlidReportsCsvApiResponse = /** status 200 OK */ string;
export type GetApiFmByFlidReportsCsvApiArg = {
    /** Feedlot Id */
    flid: number;
    /** Name of the raw SQL file */
    reportName: string;
    /** Name(s) of the raw SQL variables used. Do not need to add FeedLotId or TimezoneOffset variables. For "bit" use true/false, not 1 or 0. */
    dbParams?: {
        [key: string]: string;
    };
};
export type GetApiFmByFlidReportsExcelApiResponse = /** status 200 OK */ string;
export type GetApiFmByFlidReportsExcelApiArg = {
    /** Feedlot Id */
    flid: number;
    /** Name of the raw SQL file */
    reportName: string;
    /** Name(s) of the raw SQL variables used. Do not need to add FeedLotId or TimezoneOffset variables. For "bit" use true/false, not 1 or 0.
    SQL variables "StartDate" and "EndDate" are required for all reports that use them and the name must match exactly. When a single date is required, use the "StartDate". */
    dbParams?: {
        [key: string]: string;
    };
};
export type GetApiFmByFlidReportsSpecsApiResponse =
    /** status 200 OK */ FeedlotManagerDataRawSqlReportDetail[];
export type GetApiFmByFlidReportsSpecsApiArg = {
    flid: number;
    reportName?: string;
};
export type PostApiFmByFlidReportsRequestsApiResponse =
    /** status 200 OK */ string;
export type PostApiFmByFlidReportsRequestsApiArg = {
    flid: number;
    reportName: string;
    dbParams?: {
        [key: string]: string;
    };
    outputType?: FeedlotManagerCommonEnumsReportOutputType;
    camelCase?: boolean;
};
export type GetApiFmByFlidReportsAndTokenApiResponse = unknown;
export type GetApiFmByFlidReportsAndTokenApiArg = {
    token: string;
    flid: string;
};
export type FeedlotManagerCommonEnumsReportTypeEnum =
    | 'HospitalReport'
    | 'YardSheet';
export type FeedlotManagerCommonEnumsFileTypeEnum = 'csv' | 'pdf';
export type FeedlotManagerDataRawSqlDirectiveAction = {
    column?: number | null;
    columnName?: string | null;
    name?: string | null;
};
export type FeedlotManagerDataRawSqlDirective = {
    actions?: FeedlotManagerDataRawSqlDirectiveAction[] | null;
    name?: string | null;
};
export type FeedlotManagerDataRawSqlGrouping = {
    name?: string | null;
    normalize?: boolean;
    size?: number;
};
export type FeedlotManagerDataRawSqlParamDetail = {
    description?: string | null;
    status?: string | null;
    type?: string | null;
};
export type FeedlotManagerDataRawSqlReportDetail = {
    description?: string | null;
    directives?: FeedlotManagerDataRawSqlDirective[] | null;
    displayName?: string | null;
    groupings?: FeedlotManagerDataRawSqlGrouping[] | null;
    headerAssociations?: string[][] | null;
    headers?: string[] | null;
    paramDetails?: {
        [key: string]: string | null;
    } | null;
    params?: {
        [key: string]: FeedlotManagerDataRawSqlParamDetail;
    } | null;
    range?: string | null;
    reportName?: string | null;
    reportType?: string | null;
    status?: string | null;
};
export type FeedlotManagerCommonEnumsReportOutputType =
    | 'excel'
    | 'csv'
    | 'json'
    | 'pdf';
